// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__yJKD3","noPadding":"Section_noPadding__NXXvu","sectionContent":"Section_sectionContent__zx385"};